import { Config, ConfigDetails } from "../../types/config/config";

/**
 * Checks whether the current site matches the given siteId(s).
 * Accepts a single siteId string or an array of siteIds.
 */
export const isSite = (config: Config | ConfigDetails | null | undefined, siteId: string | string[]): boolean => {
    const cfg: Config | undefined = config
        ? (config as ConfigDetails).config ?? (config as Config)
        : undefined;

    if (!cfg || !cfg.siteId) {
        return false;
    }

    if (Array.isArray(siteId)) {
        return siteId.includes(cfg.siteId);
    }

    return cfg.siteId === siteId;
};
